<template>
  <div>
    <div
      v-if="data.statusCampaignTranslated !== 'Sent' && data.statusCampaignTranslated !== 'Rejected' && data.statusCampaignTranslated !== 'Draft'"
      ref="gridScheduleCell"
      v-closable="{
        exclude: ['gridScheduleCell'],
        handler: 'closeTooltip'
      }"
      class="grid-schedule-cell"
      @click="onCustomOpen"
    >
      <ejs-tooltip
        v-if="data.statusCampaignTranslated ==='Scheduled Active' || data.statusCampaignTranslated === 'Scheduled Inactive'"
        ref="tooltip"
        :before-render="setSelectedCampaign"
        :content="statusToolTipSchedule"
        :css-class="cssClass"
        position="BottomCenter"
        opens-on="Custom"
      >
        <span v-if="data.scheduleActive === 'Active'">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            size="xs"
            class="success"
            transform="shrink-4"
          />
          Scheduled Active
          <font-awesome-icon
            :icon="['far', 'chevron-down']"
            size="xs"
          /></span>
        <span v-else-if="data.scheduleActive === 'Inactive'">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            size="xs"
            class="danger"
            transform="shrink-4"
          />
          Scheduled Inactive
          <font-awesome-icon
            :icon="['far', 'chevron-down']"
            size="xs"
          />
        </span>
      </ejs-tooltip>
      <ejs-tooltip
        v-if="data.statusCampaignTranslated ==='Testing'"
        ref="tooltip"
        :before-render="setSelectedCampaign"
        :content="statusToolTipTesting"
        :css-class="cssClass"
        position="BottomCenter"
        opens-on="Custom"
      >
        <span>Testing <font-awesome-icon
          :icon="['far', 'chevron-down']"
          size="xs"
        /></span>
      </ejs-tooltip>
      <ejs-tooltip
        v-if="data.statusCampaignTranslated ==='Pending'"
        ref="tooltip"
        :before-render="setSelectedCampaign"
        :content="statusToolTipPending"
        :css-class="cssClass"
        position="BottomCenter"
        opens-on="Custom"
      >
        <span>Pending <font-awesome-icon
          :icon="['far', 'chevron-down']"
          size="xs"
        /></span>
      </ejs-tooltip>
      <ejs-tooltip
        v-if="data.statusCampaignTranslated ==='Approved'"
        ref="tooltip"
        :before-render="setSelectedCampaign"
        :content="statusToolTipApproved"
        :css-class="cssClass"
        position="BottomCenter"
        opens-on="Custom"
      >
        <span>Approved <font-awesome-icon
          :icon="['far', 'chevron-down']"
          size="xs"
        /></span>
      </ejs-tooltip>
      <ejs-dialog
        id="dialog"
        ref="dialogTemplate"
        :before-open="setSelectedCampaign"
        :target="target"
        :is-modal="true"
        :height="height"
        :width="width"
        :show-close-icon="false"
        :content="dialogTemplate"
        :open="dlgOpen"
        :close="dlgClose"
        :overlay-click="overlayClick"
        :visible="false"
        :animation-settings="animationSettings"
      />
      <ejs-dialog
        id="editScheduleDialogTemplate"
        ref="editScheduleDialogTemplate"
        :before-open="setSelectedCampaign"
        :target="target"
        :is-modal="true"
        :height="height"
        :width="width"
        :show-close-icon="false"
        :content="editScheduleDialogTemplate"
        :open="dlgOpen"
        :close="dlgClose"
        :overlay-click="overlayClick"
        :visible="false"
        :animation-settings="animationSettings"
      />
      <ejs-dialog
        id="rejectDialogTemplate"
        ref="rejectDialogTemplate"
        :before-open="setSelectedCampaign"
        :target="target"
        :is-modal="true"
        :height="height"
        :width="width"
        :show-close-icon="false"
        :content="rejectDialogTemplate"
        :open="dlgOpen"
        :close="dlgClose"
        :overlay-click="overlayClick"
        :visible="false"
        :animation-settings="animationSettings"
      />
      <ejs-toast
        ref="errorToastRef"
        title="Error"
        content="An error has ocurred requesting approval"
        :position="toastPosition"
        css-class="notification-error"
      />
    </div>
    <span v-if="data.statusCampaignTranslated === 'Sent' || data.statusCampaignTranslated === 'Rejected' || data.statusCampaignTranslated === 'Draft'">
      {{ data.statusCampaignTranslated }}
    </span>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import eInsightUrl from '../../constants/eInsightUrl'
import { iframeParentCommunication } from '../../mixins/iframeParentCommunication'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

import { systemTimezone, isTimeZoneFeatureEnabled } from '../../constants/general'

Vue.use(VueMoment, {
  moment
})

Vue.use(DialogPlugin)

const StatusToolTipTesting = Vue.component('StatusToolTipTesting', {
  mixins: [iframeParentCommunication],
  data () {
    return {
      data: {},
      hasEmailContentApproval: {}
    }
  },
  mounted () {
    this.data = this.$store.getters.getGridSelectedCampaign
    this.hasEmailContentApproval = this.$store.getters.getHasEmailContentApproval
  },
  methods: {
    requestApproval () {
      const parentCompanyId = this.$route.query.clientId
      const projectId = this.data.projectId
      const userEmail = atob(this.$route.query.userEmail)
      if (parentCompanyId && projectId) {
        if (this.hasEmailContentApproval.settingValue === 'Y') {
          const data = {
            action: 'eIn_send_for_approval',
            value: {
              projectId: projectId,
              companyId: this.$route.query.companyId
            }
          }
          this.SendMessageToParent(data)
        } else {
          this.$store.dispatch('requestApproval', { parentCompanyId, projectId, userEmail })
            .then(response => {
              if (response.data.status === 200) {
                this.$parent.$parent.refreshCampaignsFiltersOn()
              } else {
                console.log('error requesting approval')
                this.$refs.errorToastRef.show()
              }
            }, error => {
              console.log('error requesting approval', error)
              this.$refs.errorToastRef.show()
            })
        }
      }
    }
  },
  template: `
    <div>
      <button @click="requestApproval" class="tooltip-link btn btn-lg btn-primary">
        Request Approval
      </button>
    </div>`
})

const StatusToolTipPending = Vue.component('StatusToolTipPending', {
  mixins: [iframeParentCommunication],
  data () {
    return {
      data: {},
      hasEmailContentApproval: {},
      timezoneEnv: ''
    }
  },
  mounted () {
    this.data = this.$store.getters.getGridSelectedCampaign
    this.hasEmailContentApproval = this.$store.getters.getHasEmailContentApproval
    this.timezoneEnv = systemTimezone()
  },
  methods: {
    approve () {
      this.$store.dispatch('approveCampaign', { projectId: this.data.projectId, userEmail: atob(this.$route.query.userEmail) })
        .then(response => {
          if (response.data.status === 200) {
            this.$parent.$parent.refreshCampaignsFiltersOn()
          } else {
            console.log('error approving campaign')
            this.$refs.errorToastRef.show()
          }
        }, error => {
          console.log('error approving campaign', error)
          this.$refs.errorToastRef.show()
        })
    },
    reject () {
      this.$parent.$parent.openRejectDialog()
    },
    openApprovalDashboard () {
      const data = {
        action: 'eIn_approval_dashboard',
        value: {
          projectId: this.data.projectId,
          companyId: this.$route.query.companyId
        }
      }
      this.SendMessageToParent(data)
    }
  },
  template: `
    <div>
      <p class="tooltip-title">Approval requested by {{data.approvalRequestedBy}}</p>
      <p class="text-muted">{{data.approvalRequestedDate | dateFormat}}  ({{timezoneEnv}})</p>
      <p><a v-if="hasEmailContentApproval.settingValue==='Y'" href="javascript:void(0)" @click="openApprovalDashboard">Approval Dashboard</a></p>
      <div v-if="data.canApproveCampaign">
        <a href="javascript:void(0)" @click="approve" class="btn btn-success btn-lg" >Approve</a> 
        <a href="javascript:void(0)" @click="reject" class="btn btn-danger btn-lg">Reject</a>
      </div>
    </div>`
})

const StatusToolTipApproved = Vue.component('StatusToolTipApproved', {
  data () {
    return {
      data: {},
      eInsightUrl: {},
      timezoneEnv: ''
    }
  },
  computed: {
    ...mapState({
      isPrimary: state => state.manageCampaigns.isPrimary
    }),
    schedule () {
      return this.$store.getters.getEinsightUri + eInsightUrl.editSchedule(this.data.projectId)
    }
  },
  mounted () {
    this.data = this.$store.getters.getGridSelectedCampaign
    this.eInsightUrl = this.$parent.$parent.eInsightUrl
    this.timezoneEnv = systemTimezone()
  },
  template: `
    <div>
      <p class="tooltip-title">Approved by {{data.approvedBy}}</p>
      <p class="text-muted">{{data.approvedDate | dateFormat}} ({{timezoneEnv}})</p>
      <a :href="schedule" target="_parent" class="btn btn-lg btn-primary" v-if="isPrimary">Ready to Schedule</a>
    </div>`
})
const StatusToolTipSchedule = Vue.component('StatusToolTipSchedule', {
  data () {
    return {
      data: {},
      eInsightUrl: {},
      timezoneEnv: '',
      isTimeZoneFeatureEnabled: false
    }
  },
  computed: {
    schedule () {
      return this.$store.getters.getEinsightUri + eInsightUrl.editSchedule(this.data.projectId)
    },
    timezoneFallback () {
      return isTimeZoneFeatureEnabled() ? '' : `(${this.timezoneEnv})`
    }
  },
  mounted () {
    this.data = this.$store.getters.getGridSelectedCampaign
    this.eInsightUrl = this.$parent.$parent.eInsightUrl
    this.timezoneEnv = systemTimezone()
  },
  methods: {
    editCampaign () {
      this.$parent.$parent.openEditScheduleDialog()
    },
    activateSchedule () {
      this.$parent.$parent.openDialog()
    },
    deactivateSchedule () {
      this.$parent.$parent.openDialog()
    }
  },
  template: `
    <div>
      <p class="tooltip-title">Scheduled by {{data.scheduledBy}}</p>
      <p class="text-muted">{{data.scheduleModified | dateFormat }} ({{timezoneEnv}})</p>
      <p class="tooltip-title">Frequency</p>
      <p class="text-muted">{{data.scheduleFrequency}}</p>
      <p class="tooltip-title">Send on</p>
      <p class="text-muted">{{data.scheduleText}} {{timezoneFallback}}</p>
      <button @click="editCampaign" class="btn btn-lg btn-primary" id="editSchedule">Edit</button>
      <button v-if='data.scheduleActive === "Inactive"' class="tooltip-link btn btn-success btn-lg" @click="activateSchedule" id="activateSchedule">
          Activate
      </button>
      <button v-else-if='data.scheduleActive === "Active"' class="tooltip-link btn btn-danger btn-lg" @click="deactivateSchedule" id="cancelSchedule">
          Deactivate
      </button>
    </div>`
})

const DialogTemplate = Vue.component('DialogTemplate', {
  mixins: [iframeParentCommunication],
  data () {
    return {
      data: {},
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  computed: {
    activateSchedule () {
      return this.$store.getters.getEinsightUri + this.eInsightUrl.activateSchedule(this.data.projectId)
    },
    scheduleInTheFuture () {
      const now = moment().tz('America/New_York').format()
      const scheduleDate = this.data.scheduleDate + '-05:00'
      const inTheFuture = moment(scheduleDate).isSameOrAfter(now)
      return inTheFuture
    }
  },
  mounted () {
    this.data = this.$parent.$parent.data
    this.eInsightUrl = this.$parent.$parent.eInsightUrl
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeDialog()
    },
    updateSchedule (activate) {
      this.$store.dispatch('activateschedule', { projectId: this.data.projectId, activate: activate, userEmail: atob(this.$route.query.userEmail) })
        .then(response => {
          this.$parent.$parent.closeDialog()
          this.$parent.$parent.refreshCampaignsFiltersOn()
        }, error => {
          console.log(error)
        })
    }
  },
  template: `
    <div v-if="data.scheduleActive">
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Confirm</h2></br>
        <p v-if="data.scheduleActive === 'Inactive'">Activating this schedule will resume sending.</p>
        <p v-if="data.scheduleActive === 'Active'">Deactivating this schedule will pause sending.</p></br>
        <div class="btn btn-lg btn-outline-secondary" @click="cancel">Cancel</div>
        <a :href="activateSchedule" class="btn btn-lg btn-success" v-if="data.scheduleActive === 'Inactive' && !scheduleInTheFuture" target="_parent">Activate</a>
        <a href="javascript:void(0)" class="btn btn-lg btn-success" v-if="data.scheduleActive === 'Inactive' && scheduleInTheFuture" @click="updateSchedule(true)">Activate</a>
        <button @click="updateSchedule(false)" class="btn btn-lg btn-danger" v-if="data.scheduleActive === 'Active'">Deactivate</button>
      </div>
    </div>`
})

const EditScheduleDialogTemplate = Vue.component('EditScheduleDialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeEditScheduleDialog()
    },
    editCampaign () {
      this.$parent.$parent.editScheduledCampaign()
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Confirm</h2></br>
         <p>This project has already been scheduled.<br />
          Saving any changes to the Audience or Template will delete the existing schedule.</p>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="editCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})

const RejectDialogTemplate = Vue.component('RejectDialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      },
      reason: ''
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeRejectDialog()
    },
    rejectCampaign () {
      this.$parent.$parent.rejectCampaign(this.reason)
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Reject Confirm</h2></br>
         <p>Are you sure you wish to reject this campaign?</p>
         <div class="form-group">
          <label for="textarea" class="col-form-label">Please explain:</label>
          <textarea class="form-control" id="textarea" v-model="reason"></textarea>
        </div>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="rejectCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})

export default {
  name: 'GridSchedule',
  mixins: [iframeParentCommunication],
  data () {
    return {
      data: {},
      cssClass: 'customtip',
      target: '#app',
      height: '',
      width: '400px',
      toastPosition: { X: 'Right', Y: 'Top' },
      animationSettings: { effect: 'Fade', duration: 100 },
      statusToolTipTesting () {
        return {
          template: StatusToolTipTesting
        }
      },
      statusToolTipPending () {
        return {
          template: StatusToolTipPending
        }
      },
      statusToolTipApproved () {
        return {
          template: StatusToolTipApproved
        }
      },
      statusToolTipSchedule () {
        return {
          template: StatusToolTipSchedule
        }
      },
      dialogTemplate () {
        return {
          template: DialogTemplate
        }
      },
      editScheduleDialogTemplate () {
        return {
          template: EditScheduleDialogTemplate
        }
      },
      rejectDialogTemplate () {
        return {
          template: RejectDialogTemplate
        }
      },
      eInsightUrl: eInsightUrl
    }
  },
  computed: {
    ...mapGetters([
      'getGridSelectedCampaign'
    ])
  },
  methods: {
    setSelectedCampaign () {
      this.$store.commit('SET_GRIDSELECTEDCAMPAIGNS', this.data)
    },
    onCustomOpen (args) {
      if (args.target.getAttribute('data-tooltip-id')) {
        this.$refs.tooltip.close()
      } else {
        this.$refs.tooltip.open(args.target)
      }
    },
    closeTooltip () {
      this.$refs.tooltip.close()
    },
    openDialog () {
      this.$refs.dialogTemplate.show()
    },
    closeDialog () {
      this.$refs.dialogTemplate.hide()
    },
    openEditScheduleDialog () {
      this.$refs.editScheduleDialogTemplate.show()
    },
    closeEditScheduleDialog () {
      this.$refs.editScheduleDialogTemplate.hide()
    },
    openRejectDialog () {
      this.$refs.rejectDialogTemplate.show()
    },
    closeRejectDialog () {
      this.$refs.rejectDialogTemplate.hide()
    },
    editScheduledCampaign () {
      const uri = '/Project.mvc/Project/EditSchedule?projectId=' + this.getGridSelectedCampaign.projectId + '#schedule'
      const data = { action: 'eIn_redirect', value: uri }
      this.SendMessageToParent(data)
      this.$refs.editScheduleDialogTemplate.hide()
    },
    rejectCampaign (reason) {
      this.$store.dispatch('rejectCampaign', { projectId: this.getGridSelectedCampaign.projectId, reason: reason, userEmail: atob(this.$route.query.userEmail) })
        .then(response => {
          if (response.data.status === 200) {
            this.refreshCampaignsFiltersOn()
          } else {
            console.log('error reject campaign')
            this.$refs.errorToastRef.show()
          }
          this.closeRejectDialog()
        }, error => {
          console.log('error reject campaign', error)
          this.$refs.errorToastRef.show()
          this.closeRejectDialog()
        })
    },
    dlgClose () {
    },
    dlgOpen () {
      document.getElementById('sendButton').keypress = (e) => {
        if (e.keyCode === 13) { console.log('pressed') }
      }
      document.getElementById('inVal').onkeydown = (e) => {
        if (e.keyCode === 13) { console.log('pressed') }
      }
      document.getElementById('sendButton').onclick = () => {
        console.log('pressed')
      }
    },
    overlayClick: function () {
      this.$refs.dialogTemplate.hide()
      this.$refs.editScheduleDialogTemplate.hide()
      this.$refs.rejectDialogTemplate.hide()
    },
    refreshCampaignsFiltersOn () {
      const filters = this.$store.state.manageCampaigns.filtersData
      this.$store.dispatch('setCampaignsByPage', {
        companyId: this.$route.query.companyId,
        isPrimary: this.$parent.$parent.$parent.$parent.primary,
        userEmail: atob(this.$route.query.userEmail),
        dataState: filters
      })
    },
    refreshCampaigns () {
      this.$store.dispatch('setCampaignsByPage', {
        companyId: this.$route.query.companyId,
        isPrimary: this.$parent.$parent.$parent.$parent.primary,
        userEmail: atob(this.$route.query.userEmail)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap4.css';
.grid-schedule-cell:hover {
  cursor: pointer;
}
a.tooltip-link, .link-default {
  text-decoration: none;
  color: #666;
}
.success {
  color: $success;
}
.danger {
  color: $danger;
}
.unset {
  color: $gray-medium;
}
.svg-inline--fa {
  vertical-align: 0;
}
</style>
